const Nalaz = function(DS) {
    return DS.defineResource({
        name: 'OperativniNalaz',
        endpoint: '/nalazi'
    });
};

Nalaz.$inject = ['DS'];

export {Nalaz};



// WEBPACK FOOTER //
// ./app/models/nalaz.js